import { useState, useEffect, useContext } from "react";
import {
  Box,
  FormControl,
  Select,
  Radio,
  Typography,
  ListSubheader,
  Divider,
  RadioGroup,
  FormControlLabel,
} from "@mui/material";
import { GlobalContext } from "../../common/Context";
import { useTranslation } from "react-i18next";

const DropdownRadioList = ({
  options,
  dropdownTitle,
  onUpdate,
  showPersonalStats,
  allTeams,
  profileID,
}) => {
  const { t } = useTranslation("Stats");
  const { mobileView, tabletView } = useContext(GlobalContext);

  const boxStyle = {
    width: mobileView ? "100%" : tabletView ? "50%" : "30%",
    height: "3.5rem",
    mb: mobileView ? "2rem" : "0",
  };
  const textStyle = {
    color: "#2e117f",
  };
  const formStyle = {
    width: "100%",
    height: "75%",
    backgroundColor: "white",
    borderRadius: "0.25rem",
  };
  const selectStyle = {
    height: "100%",
    "& .MuiOutlinedInput-input": {},
    "& .MuiOutlinedInput-notchedOutline": {
      border: "solid 2px #2E117F",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: "solid 2px #C31CF3",
    },
    "&:hover": {
      "& .MuiOutlinedInput-notchedOutline": { border: "solid 2px #2E117F" },
    },
  };
  const menuStyle = {
    maxHeight: "20rem",
  };
  const radioStyle = {
    ml: "1rem",
  };
  const subHeaderStyle = {
    color: "#8157d1",
    display: "flex",
    flexDirection: "row",
  };

  const [toggled, setToggled] = useState(
    !profileID && options.length
      ? options[0].id.toString()
      : showPersonalStats
      ? "Personal"
      : "All Teams",
  );
  const [displayValue, setDisplayValue] = useState(
    !profileID && options.length
      ? options[0].name
      : showPersonalStats
      ? "Personal"
      : "All Teams",
  );
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  });

  const handleToggle = (e) => {
    if (isNaN(e.target.value)) {
      setDisplayValue(e.target.value);
      onUpdate({ name: e.target.value, id: e.target.value });
    } else {
      options.forEach((option) => {
        if (option.id.toString() === e.target.value) {
          setDisplayValue(option.name);
          onUpdate({ name: option.name, id: e.target.value });
        }
      });
    }
    setToggled(e.target.value);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleScroll = () => {
    setIsOpen(false);
  };

  return (
    <Box sx={boxStyle}>
      <Typography sx={textStyle} variant="body2">
        {dropdownTitle}
      </Typography>
      <FormControl sx={formStyle}>
        <Select
          sx={selectStyle}
          value={displayValue}
          onClose={handleClose}
          onOpen={handleOpen}
          open={isOpen}
          MenuProps={{ PaperProps: { sx: menuStyle } }}
          renderValue={() => {
            return displayValue;
          }}>
          <RadioGroup onChange={handleToggle} sx={radioStyle}>
            {allTeams && (
              <>
                <ListSubheader sx={subHeaderStyle}>
                  <img
                    src="images/trypscore-icon.svg"
                    alt="Personal Data"
                    width="40px"
                  />
                  {t("allTeams")}
                </ListSubheader>
                <FormControlLabel
                  label={t("allTeams")}
                  control={
                    <Radio
                      sx={radioStyle}
                      checked={toggled === t("allTeams")}
                      value={t("allTeams")}
                    />
                  }
                />
              </>
            )}
            {showPersonalStats && (
              <>
                <ListSubheader sx={subHeaderStyle}>
                  <img
                    src="images/trypscore-icon.svg"
                    alt="Personal Data"
                    width="40px"
                  />
                  {t("personalStats")}
                </ListSubheader>
                <FormControlLabel
                  label={t("personalStats")}
                  control={
                    <Radio
                      sx={radioStyle}
                      checked={toggled === t("personal")}
                      value={t("personal")}
                    />
                  }
                />
              </>
            )}
            <Divider />
            <ListSubheader sx={subHeaderStyle}>
              <img
                src="images/team-icon-01.svg"
                alt="Teams Icon"
                width="40px"
              />
              {t("myTeams")}
            </ListSubheader>
            {options?.map((option) => (
              <>
                <FormControlLabel
                  label={option.name}
                  control={
                    <Radio
                      sx={radioStyle}
                      checked={toggled === option.id.toString()}
                      value={option.id}
                    />
                  }
                />
              </>
            ))}
          </RadioGroup>
        </Select>
      </FormControl>
    </Box>
  );
};
export default DropdownRadioList;
